import { render, staticRenderFns } from "./BayOnDeckHatchCovers.vue?vue&type=template&id=b7fb53be&scoped=true"
import script from "./BayOnDeckHatchCovers.vue?vue&type=script&lang=ts"
export * from "./BayOnDeckHatchCovers.vue?vue&type=script&lang=ts"
import style0 from "./BayOnDeckHatchCovers.vue?vue&type=style&index=0&id=b7fb53be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fb53be",
  null
  
)

export default component.exports